import { createListenerMiddleware } from '@reduxjs/toolkit';

import { authApi } from '~services/api/auth';

export const imageLoadingTrackingInit = createListenerMiddleware();

// remove this code after 10.2025
// we dont want to intercept and break image caching
imageLoadingTrackingInit.startListening({
	matcher: authApi.endpoints.authenticate.matchFulfilled,
	effect: () => {
		if ('serviceWorker' in navigator) {
			void navigator.serviceWorker.getRegistrations().then((registrations) => {
				registrations.forEach((registration) => {
					if (
						registration.scope.includes('image-loading-tracking-sw.js') ||
						(registration.active &&
							registration.active.scriptURL.includes(
								'image-loading-tracking-sw.js'
							))
					) {
						void registration.unregister().then((success) => {
							if (success) {
								// eslint-disable-next-line no-console
								console.log(
									'image-loading Service Worker successfully unregistered'
								);
							} else {
								// eslint-disable-next-line no-console
								console.log(
									'image-loading Service Worker unregistration failed'
								);
							}
						});
					}
				});
			});
		}
	},
});
